<!-- TODO: Component under development. Commented code will be removed or added as the Sports module refactoring progresses. -->
<!-- <div class="sports-bet-button--content" [ngClass]="{'is-selected': selected, 'locked':isLocked(), 'disabled':disabled() }"> -->
<div class="sports-bet-button--content">
  <ion-icon
    *ngIf="!mode && game?.upOdd"
    name="caret-up-outline"
    class="caret-up-outline"
    color="success"
    [ngClass]="{ 'sports-button-bet-animation': game?.downOdd }"
  >
  </ion-icon>
  <p class="sports-bet-button--title color-muted">
    {{ game?.Name | sportsGetNameResult: [type, typeName, index, isCombined, home, away, sport] }}
  </p>
  <p
    class="sports-bet-button--subtitle color-dark"
    [ngClass]="{
    'is-up': !!mode && game?.upOdd,
    'is-down': !!mode && game?.downOdd
  }"
  >
    {{ game?.Odd | sportsFormatOdd }}
    <!-- <i></i> -->
  </p>
  <ion-icon
    *ngIf="!mode && game?.downOdd"
    name="caret-down-outline"
    class="caret-down-outline"
    color="danger"
    [ngClass]="{ 'sports-button-bet-animation': game?.downOdd }"
  >
  </ion-icon>
</div>
